import React, { createContext, useContext, useState } from 'react'

import Footer from 'components/Footer/Footer'
import Header from 'components/Header/Header'
import { FormTypes } from 'models'
import { useOutlet } from 'react-router'

import styles from './Wrapper.module.scss'
import { scrollIntoElement } from 'shared/utils'
import { PartnersBlockFormId } from '../Partners'

type Props = {
  headerWhite: boolean
  setHeaderWhite: (visible: boolean) => void
  isHeaderFixed: boolean
  setHeaderFixed: (isFixed: boolean) => void
  formOpened: FormTypes | undefined
  setFormOpened: (formType: FormTypes | undefined) => void
}

const WrapperContext = createContext<Props>({
  headerWhite: false,
  setHeaderWhite: visible => visible,
  isHeaderFixed: false,
  setHeaderFixed: isFixed => isFixed,
  formOpened: undefined,
  setFormOpened: formType => formType,
})

export const useWrapperContext = (): Props => useContext(WrapperContext)

export const Wrapper = (): JSX.Element => {
  const outlet = useOutlet()
  const [isHeaderFixed, setHeaderFixed] = useState(false)
  const [headerWhite, setHeaderWhite] = useState(false)
  const [formOpened, setFormOpened] = useState<FormTypes | undefined>(undefined)

  const _setFormOpened = (formType: FormTypes | undefined) => {
    setFormOpened(formType)
    scrollIntoElement(PartnersBlockFormId, undefined, true)
  }

  return (
    <WrapperContext.Provider
      value={{
        headerWhite,
        setHeaderWhite,
        isHeaderFixed,
        setHeaderFixed,
        formOpened,
        setFormOpened: _setFormOpened,
      }}
    >
      <Header />
      <div className={styles.container}>{outlet}</div>
      <Footer />
    </WrapperContext.Provider>
  )
}
